<script setup lang="ts">
import { ToastClose, ToastDescription, ToastRoot } from "reka-ui";
import type { Toast } from "@/schemas/toast";

defineProps<{ toast: Toast }>();
</script>

<template>
  <ToastRoot
    :duration="toast.duration"
    class="animation-fade relative flex items-start gap-2.5 overflow-hidden rounded-lg border border-primary bg-white p-4 shadow-lg focus:outline-none"
  >
    <template #default="{ remaining, duration }">
      <span
        class="size-6 shrink-0"
        :class="{
          'i-lucide-check-circle text-success': toast.type === 'success',
          'i-lucide-triangle-alert text-danger': toast.type === 'error',
          'i-lucide-info text-muted': toast.type === 'info',
        }"
      />
      <div class="flex flex-1 flex-col gap-1">
        <ToastDescription class="text-base" v-html="toast.content" />
        <div class="flex flex-wrap gap-1 self-end">
          <UiLink v-for="(link, i) in toast.links" :key="i" :link="link" />
        </div>
      </div>
      <ToastClose class="">
        <span class="i-lucide-x size-6 -translate-y-3 translate-x-3" />
      </ToastClose>
      <div class="absolute inset-x-0 bottom-0 h-1 bg-primary" :style="`width: ${((remaining / duration) * 100)}%`" />
    </template>
  </ToastRoot>
</template>
